export default "__VITE_ASSET__BFVOBxjM__"